import React, { useEffect, useRef, useState } from 'react'
import Quagga from '@ericblade/quagga2'

const QrScanner = ({
    readerType,
    onDetected,
}) => {
    const scannerRef = useRef()
    const [cameraUid, setCameraUid] = useState(null)
    const [cameraDevices, setCameraDevices] = useState([])

    const onProcessed = result => {
        const drawingCtx = Quagga.canvas.ctx.overlay
        const drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
            if (result.boxes) {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                });
            }

            if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
        }
    }

    const onDetectedBase = result => {
        onDetected(result.codeResult.code)
    }

    const initQuagga = () => {
        let options = {
            target: scannerRef.current,
            inputStream: {
                type : "LiveStream",
                constraints: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    facingMode: "environment", // or user
                    // deviceId: '123'
                }
            },
            debug: {
                drawBoundingBox: true,
                showFrequency: true,
                drawScanline: true,
                showPattern: true
            },
            locator: {
                patchSize: "medium",
                halfSample: true,
            },
            numOfWorkers: 4,
            decoder: {
                readers : [
                    readerType || 'ean_reader',
                    // 'code_128_reader',
                    // 'ean_reader',
                    // 'ean_8_reader',
                    // 'code_39_reader',
                    // 'code_39_vin_reader',
                    // 'codabar_reader',
                    // 'upc_reader',
                    // 'upc_e_reader',
                    // 'i2of5_reader',
                    // '2of5_reader',
                    // 'code_93_reader',
                ]
            },
            multiple: false,
            locate: true,
        }

        if (cameraUid) {
            options.inputStream.constraints.deviceId = cameraUid
        }

        Quagga.init(options, function(err) {
            if (err) {
                return console.log(err)
            }
            Quagga.start()
        })
    }

    const initCameraSelection = () => (
        Quagga
            .CameraAccess
            .enumerateVideoDevices()
            .then(function(devices) {
                setCameraUid(devices[devices.length - 1].deviceId)
                setCameraDevices(devices)
            })
    )

    const startTorch = () => (
        Quagga
            .CameraAccess
            .getActiveTrack()
            .applyConstraints({ advanced: [{ torch: true }] })
    )


    useEffect(() => {
        initCameraSelection()

        if (scannerRef.current && cameraUid) {
            initQuagga()

            Quagga.onDetected(onDetectedBase)
            Quagga.onProcessed(onProcessed)
        }

        return () => Quagga.offDetected(onDetectedBase)
    }, [scannerRef, cameraUid])

    return (
        <>
            <div className="d-flex w-100 align-items-center justify-content-between">
                <select
                    onChange={event => setCameraUid(event.target.value)}
                    value={cameraUid || ''}
                >
                    {cameraDevices?.map?.((device, index) => (
                        <option
                            value={device.deviceId}
                            key={`device-camera-${index}`}
                        >
                            {device.label}
                        </option>
                    )) }
                </select>
                <div onClick={startTorch} className="btn btn-outline-info btn-sm">Baterka</div>
            </div>
            <div
                ref={scannerRef}
                id="interactive"
                className="viewport"
            />

        </>
    )
}

export default QrScanner